export default "__VITE_ASSET__f2c26bc0__"